export { default } from './ChessRook'
